import HTTPServices from "../HTTPServices/httpService";
import moment from "moment";

const commonServices = {
  //(1)
  uniqueOfArray: function (array, columnName) {
    // alert("array " + array.length + ",  " + columnName);

    var flags = [],
      output = [],
      l = array.length,
      i;
    for (i = 0; i < l; i++) {
      // alert(
      //   "array[i].orderDetailID_GUID: " +
      //     JSON.stringify(array[i]) +
      //     array[i][columnName]
      // );
      if (flags[array[i][columnName]]) continue;
      flags[array[i][columnName]] = true;
      output.push(array[i]);
    }

    console.log("OutPut : " + output);
    // alert(
    //   "array unique output " + output.length + ",  " + JSON.stringify(output)
    // );

    return output;
  },

  addDays: function (date, days) {
    var result = new Date(date);
    result.setDate(date.getDate() + days);
    return result;
  },
  converStringToDate: function (dateString) {
    //  Convert a "dd/MM/yyyy" string into a Date object
    let d = dateString.split("-");
    let dat = new Date(d[2] + "/" + d[1] + "/" + d[0]);
    return dat;
  },

  showDateRemovedT: function (dateString) {
    return moment(dateString).utc().format("YYYY-MM-DD");
  },
};

export default commonServices;
